import type {
  IExportTokenUsageByModelParams,
  IGetTokenUsageByModelParams,
  IGetTokenUsageByModelResponse,
  IGetTokenUsageParams,
  IGetTokenUsageResponse,
  IGetTokenUsageSummaryParams,
  IGetTokenUsageSummaryResponse,
  IGetTokenUsageTrendsParams,
  IGetTokenUsageTrendsResponse,
} from "../types/token-usage";
import type { ApiClient } from "./client";

export class TokenUsageApi {
  constructor(private apiClient: ApiClient) {}

  async getTokenUsage(
    params: IGetTokenUsageParams,
  ): Promise<IGetTokenUsageResponse> {
    const response = await this.apiClient.get<IGetTokenUsageResponse>(
      "/token-usage",
      { params },
    );
    return response.data;
  }

  async getTokenUsageSummary(
    params: IGetTokenUsageSummaryParams,
  ): Promise<IGetTokenUsageSummaryResponse> {
    const response = await this.apiClient.get<IGetTokenUsageSummaryResponse>(
      "/token-usage/summary",
      { params },
    );
    return response.data;
  }

  async getTokenUsageByModel(
    params: IGetTokenUsageByModelParams,
  ): Promise<IGetTokenUsageByModelResponse> {
    const response = await this.apiClient.get<IGetTokenUsageByModelResponse>(
      "/token-usage/by-model",
      { params },
    );
    return response.data;
  }

  async getTokenUsageTrends(
    params: IGetTokenUsageTrendsParams,
  ): Promise<IGetTokenUsageTrendsResponse> {
    const response = await this.apiClient.get<IGetTokenUsageTrendsResponse>(
      "/token-usage/by-model/trends",
      { params },
    );
    return response.data;
  }

  async exportTokenUsageByModel(
    params: IExportTokenUsageByModelParams,
  ): Promise<Blob> {
    const response = await this.apiClient.get<Blob>(
      "/token-usage/by-model/export",
      { params, responseType: "blob" },
    );
    return response.data;
  }
}
